import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './medicalOfficerLayout.css';
import { MHeader } from '../../Header/MHeader';
import {MedicalOfficerApplications} from '../../medicalofficer/MedicalOfficerApplications';
import MedicalOfficerMenu from '../../medicalofficer/medicalofficermenu/MedicalOfficerMenu';
import {MedicalOfficerActivities} from '../../medicalofficer/MedicalOfficerActivities';
import {MedicalApprovedApplication} from '../../medicalofficer/MedicalApprovedApplication';
import {MedicalOfficerProfile} from '../../medicalofficer/MedicalOfficerProfile';



interface MedicalOfficerLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const MedicalOfficerLayout: React.FC<MedicalOfficerLayout> = ({ children }) => {


  return (
    <div className="elitecap-layout-container">
      <MHeader/>
      <div >
        <MedicalOfficerMenu />
]          <Routes>
             <Route path="/medicalofficerapplications" element={<MedicalOfficerApplications />} />
             <Route path="/mactivity" element={<MedicalOfficerActivities />} />
             <Route path="/mviewapproved/:id" element={<MedicalApprovedApplication/>} />
             <Route path="/mviewapplied/:id" element={<MedicalApprovedApplication/>} />
            <Route path="/mviewall/:id" element={<MedicalApprovedApplication/>} />
            <Route path="/mprofile" element={<MedicalOfficerProfile/>} />



             
             




             






          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default MedicalOfficerLayout;
